import React from 'react';
import { Box, Typography } from '@mui/material';

const HomeLoan = () => {
  const loanFaqs = {
    "title": "Home Loan Guide",
    "content": [
      {
        "question": "What types of Home Loans are available?",
        "answer": "A variety of home loans are available, including:",
        "details": [
          {
            "type": "Home Purchase Loan",
            "description": "For buying an existing home."
          },
          {
            "type": "Home Improvement Loan",
            "description": "For repairing or renovating a home."
          },
          {
            "type": "Home Construction Loan",
            "description": "For building a new home."
          },
          {
            "type": "Home Extension Loan",
            "description": "For expanding an existing home, such as adding a new room."
          },
          {
            "type": "Land Purchase Loan",
            "description": "For purchasing land for residential purposes."
          },
          {
            "type": "Balance Transfer Loan",
            "description": "Allows you to switch your loan to a new lender with a lower interest rate."
          },
          {
            "type": "Refinance Loan",
            "description": "Used to pay off loans from private lenders (family, friends) taken for purchasing a property."
          },
          {
            "type": "Loans for NRIs",
            "description": "Tailored for Non-Resident Indians (NRIs) to purchase homes in India."
          }
        ]
      },
      {
        "question": "What is an EMI (Equated Monthly Installment)?",
        "answer": "An EMI is the fixed monthly payment you make towards the repayment of your home loan. It consists of both the principal and the interest portion."
      },
      {
        "question": "What are the eligibility criteria for a home loan?",
        
        "answer": [
          "Be an Indian resident or NRI.",
          "Be at least 24 years old when the loan starts.",
          "Be under 60 years old (or retirement age) when the loan matures.",
          "Be either self-employed or employed with a stable income."
        ]
      },
      {
        "question": "How are interest rates for home loans calculated? What is the difference between Daily, Monthly, and Annual Reducing Balance?",
        "answer": "Interest rates vary by institution, typically ranging from 8.75% to 12%. The calculation of interest can be done on different bases:",
        "details": [
          {
            "type": "Annual Reducing",
            "description": "The principal reduces only at the end of the year, which results in a higher EMI."
          },
          {
            "type": "Monthly Reducing",
            "description": "The principal reduces every month, which reduces the EMI over time."
          },
          {
            "type": "Daily Reducing",
            "description": "The principal reduces daily, meaning you pay less interest over time, resulting in a lower EMI compared to monthly reducing balance loans."
          }
        ]
      },
      {
        "question": "What is a Fixed Rate of Interest?",
        "answer": "A fixed interest rate remains unchanged throughout the loan tenure. This means you won't benefit from any decrease in the market rates, but your payments will be predictable."
      },
      {
        "question": "What is a Floating Rate?",
        "answer": "A floating rate is tied to the market lending rates, meaning it can change over time. You may end up paying more if interest rates rise, but you could also benefit from a decrease in rates."
      },
      {
        "question": "What additional costs are associated with home loans?",
        "answer": "Apart from the principal and interest, there are other costs involved, such as:",
        "details": [
          {
            "type": "Processing Fee",
            "description": "A fee paid when applying for the loan. It can be a fixed amount or a percentage of the loan."
          },
          {
            "type": "Prepayment Penalty",
            "description": "A fee charged if you repay the loan before the scheduled tenure, typically around 2% of the prepaid amount."
          },
          {
            "type": "Miscellaneous Fees",
            "description": "Some lenders may charge documentation or consultancy fees."
          }
        ]
      },
      {
        "question": "How is the loan amount decided by Housing Finance Companies (HFCs)?",
        "answer": "Typically, HFCs will lend up to 85% of the home’s cost. The remaining 15%, known as ‘seed money,’ is provided by the borrower. The loan eligibility depends on factors like your age, income, number of dependents, and repayment capacity."
      },
      {
        "question": "Are any securities required for a home loan?",
        "answer": "The property being purchased typically acts as collateral for the loan. However, some lenders may require additional securities like life insurance policies, Fixed Deposits (FDs), or share certificates."
      },
      {
        "question": "How long does it take for loan disbursement?",
        "answer": "Loan disbursement usually takes between 3 to 15 days, provided all documentation is complete and satisfactory. You must also pay the 15% upfront amount to the property seller."
      },
      {
        "question": "What tax benefits are available with home loans?",
        "answer": "Both the principal and interest paid on home loans offer tax benefits under the Income Tax Act:",
        "details": [
          {
            "type": "Principal Repayment",
            "description": "Up to Rs 1,50,000 per year under section 80C."
          },
          {
            "type": "Interest Payment",
            "description": "Up to Rs 2,00,000 per year under section 24(b) after the completion of the home construction."
          }
        ]
      }
    ]
  };

  return (
    <Box sx={{ p: 3, mt: 12 }}>
      <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
        {loanFaqs.title}
      </Typography>
      <Box sx={{ p: 3, mt: 2 }}>
        {loanFaqs.content.map((faq, index) => (
          <div key={index}>
            <Typography variant="h6" sx={{ fontWeight: 550, fontSize: '14px' }}>
              {faq.question}
            </Typography>
            <Typography variant="body1" sx={{ color: '#666', mb: 2, fontSize: '14px' }}>
              {faq.answer}
            </Typography>
            {faq.details && Array.isArray(faq.details) && (
              <ul style={{ fontSize: '14px' }}>
                {faq.details.map((item, idx) => (
                  <li key={idx}>
                    <strong>{item.type}:</strong> {item.description}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default HomeLoan;
